const avatarSizes = {
    sm: "50px",
    md: "100px",
    lg: "150px"
};

export { avatarSizes };
